import i18n from '@/i18n'

export function getLocaleValueFor(
  key: string,
  throwExceptionIfNotFound = false,
) {
  if (!key) {
    const msg = 'Locale key must contain a value'
    if (throwExceptionIfNotFound) {
      throw new Error(msg)
    }
    console.error(msg)
    return ''
  }

  // vue-i18n's overloaded `t`/`te` trigger TS2589 (excessively deep
  // instantiation); access them through a loosely-typed global to keep
  // type-checking tractable.
  const global = i18n.global as unknown as {
    t: (k: string) => string
    te: (k: string) => boolean
  }
  // Probe existence with `te` rather than translating and comparing: this is an
  // intentional optional lookup, so it must not trip vue-i18n's missingWarn.
  // A missing key is reported here, deliberately and once.
  if (!global.te(key)) {
    const msg = `Locale key ${key} not found`
    if (throwExceptionIfNotFound) {
      throw new Error(msg)
    }
    console.warn(msg)
    // Preserve previous behaviour: `t()` returned the key itself on a miss.
    return key
  }

  return global.t(key).toString()
}
